import React from "react";
import { useTranslation } from "react-i18next";
import "./culture.css";
import SectionWrapper from "../components/ComponentWrapper/SectionWrapper";
import BreathingBackground from "../components/BreathingBackground/BreathingBackground";

const Culture = () => {
  const { t } = useTranslation();

  return (
    <BreathingBackground>
    <SectionWrapper>
    <article className="culture-page">
      {/* HERO */}
      <header className="culture-hero">
        <h1>{t("culture.title", "Culture & Community")}</h1>
        <p>
          {t(
            "culture.subtitle",
            "Music as a living cultural practice"
          )}
        </p>
      </header>

      {/* CONTEXTO */}
      <section className="culture-section">
        <h2>{t("culture.contextTitle", "Mixe cultural context")}</h2>
        <p>
          {t(
            "culture.contextText",
            "Kujipy belongs to the Mixe people of Oaxaca, an Indigenous culture where music is inseparable from community life, territory, and collective memory."
          )}
        </p>
        <p>
          {t(
            "culture.contextText2",
            "Music accompanies rituals, festivities, and social organization, reinforcing bonds between generations."
          )}
        </p>
      </section>

      {/* MUSICA Y COMUNIDAD */}
      <section className="culture-section highlight">
        <h2>{t("culture.musicTitle", "Music and community")}</h2>
        <p>
          {t(
            "culture.musicText",
            "In the Mixe tradition, music is not conceived as a stage spectacle alone. It is a communal act where musicians, dancers, and audience share the same space and time."
          )}
        </p>
        <p>
          {t(
            "culture.musicText2",
            "Kujipy preserves this perspective in every performance, prioritizing collective participation over individual virtuosity."
          )}
        </p>
      </section>

      {/* BAILE */}
      <section className="culture-section">
        <h2>{t("culture.danceTitle", "Dance as cultural expression")}</h2>
        <p>
          {t(
            "culture.danceText",
            "Dance plays a central role in Mixe music. Pieces such as Baltiptsy (The Mole Dance) are meant to be danced, embodying stories, symbols, and relationships with the land."
          )}
        </p>
      </section>

      {/* TERRITORIO */}
      <section className="culture-section highlight">
        <h2>{t("culture.landTitle", "Territory and identity")}</h2>
        <p>
          {t(
            "culture.landText",
            "The Mixe territory shapes sound, rhythm, and movement. Kujipy’s music reflects the mountainous landscape of Santa María Tlahuitoltepec and its communal way of life."
          )}
        </p>
      </section>

      {/* CIERRE */}
      <section className="culture-section">
        <p className="culture-closing">
          {t(
            "culture.closing",
            "Through international performances, Kujipy shares this cultural practice with respect and responsibility, presenting Mixe music as a living and evolving tradition."
          )}
        </p>
      </section>
      <div className="epk-inline">
        <p>{t("common.cultureEpk")} <a href="/epk" className="editorial-link">EPK</a>.</p>
      </div>
    </article>
    </SectionWrapper>
    </BreathingBackground>
  );
};

export default Culture;
